import request from '@/utils/request'

// 获取所有解决方案
export function solutionList (params) {
  return request({
    url: '/api/solution/all',
    method: 'get',
    params,
  })
}

// 获取解决方案首页
export function solutionText (params) {
  return request({
    url: '/api/solution.recommand/index',
    method: 'get',
    params,
  })
}

// 获取所有子类
export function solutionPid (params) {
  return request({
    url: '/api/solution/getListByPid',
    method: 'get',
    params,
  })
}

// 解决方案详情
export function solutionDetail (params) {
  return request({
    url: '/api/solution/find',
    method: 'get',
    params,
  })
}

export function callOur (data) {
  return request({
    url: '/api/contact/add',
    method: 'post',
    data,
  })
}
